var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"systems-instance-controls-template"},[_c('div',{staticClass:"left-side"},[_vm._t("left-side")],2),_c('div',{staticClass:"right-side"},[_vm._t("right-side")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }